import { useChecklistContext } from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';

export const ElectoralRollRefName = 'electoral-roll';

export default function ElectoralRollSection() {
  const { checklist } = useChecklistContext();

  const {
    electoralRoll,
  } = checklist ?? {};

  return (
    <PaddedGenericSection
      refName={ElectoralRollRefName}
      section={ChecklistSection.ELECTORAL_ROLL}
      checklistItem={electoralRoll}
    >
      <p>level 0</p>
    </PaddedGenericSection>
  );
}
